import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics, Analytics } from "firebase/analytics";
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';

// ============================================================
// FIREBASE CONFIGURATION - PRODUCTION FIRST
// ============================================================
// Emulators are ONLY used when VITE_USE_FIREBASE_EMULATOR=true
// This prevents accidental emulator connections in production
// ============================================================

import { getBooleanEnv } from '../utils/env';

// Explicit emulator flag - must be set to 'true' to use emulators
const USE_EMULATOR = getBooleanEnv('VITE_USE_FIREBASE_EMULATOR');

// Detect localhost for informational logging only
const isLocalHost = typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
);

// Production Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBHO1SDc3-ZTtTsoTHCh5zbDU1MoaHkCq4",
    authDomain: "dfr-living-reliability-system.firebaseapp.com",
    projectId: "dfr-living-reliability-system",
    storageBucket: "dfr-living-reliability-system.firebasestorage.app",
    messagingSenderId: "933555815330",
    appId: "1:933555815330:web:12d238ed7f5ff1671228fb",
    measurementId: "G-DBQM4WJ9S3"
};

// Initialize Firebase (Singleton pattern to prevent HMR errors)
let app;
let analytics: Analytics | null = null;

if (getApps().length === 0) {
    app = initializeApp(firebaseConfig);

    // Log configuration
    console.log('🔥 Firebase Configuration:');
    console.log(`   → Project: ${firebaseConfig.projectId}`);
    console.log(`   → Is Localhost: ${isLocalHost}`);
    console.log(`   → Use Emulator: ${USE_EMULATOR}`);

    if (USE_EMULATOR) {
        // Connect to local emulators ONLY when explicitly enabled
        const auth = getAuth(app);
        connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });

        const db = getFirestore(app);
        connectFirestoreEmulator(db, '127.0.0.1', 8080);

        console.log('🔧 EMULATOR MODE: Connected to Firebase Emulators');
        console.log('   → Auth: http://127.0.0.1:9099');
        console.log('   → Firestore: 127.0.0.1:8080');
        console.log('📊 Analytics DISABLED in emulator mode');
    } else {
        // Production: Use real Firebase services
        console.log('✅ PRODUCTION MODE: Using Firebase Cloud Services');
        console.log('   → Google Sign-In will use real Firebase Auth');

        try {
            analytics = getAnalytics(app);
            console.log('📊 Analytics enabled');
        } catch (e) {
            console.warn('Analytics initialization failed:', e);
        }
    }
} else {
    app = getApp();
}

export { app, analytics };

